import { createApp } from 'vue';
import FindYourMatch from '../vue/components/findYourMatch/findYourMatch.vue';
import store from '../store/index';



export namespace FindYourMatchVueApp {
	let setupVueComponent = () => {
		let findYourMatchEl = document.querySelector('.js-find-your-match');
		if(findYourMatchEl) {
			const app = createApp(FindYourMatch);
			app.use(store);
			app.mount('.js-find-your-match');
		}
	}


	export const init = () => {
		setupVueComponent();
	}
}


document.addEventListener('DOMContentLoaded', FindYourMatchVueApp.init);
